export const testimonials = [
  {
    review: 'Amazing , Welcome to the Future !!',
    name: 'Rahul Attery',
    designation: 'Senior Manager, Digidarts',
    color: 'bg-violet-500',
  },
  {
    review:
      'It is an amazing tool, i personally was benefitted with good engagement from mt linkedin fam. Highly recommend this AI',
    name: 'Samridhi Bhagat',
    designation: 'Founder The Social Minder',
    color: 'bg-teal-500',
  },
  {
    review:
      'Great Extension, Helps a lot to me in reaching out people on linkedin, Framing connection messages, etc',
    name: 'Madhur Gera',
    designation: 'SDE ',
    color: 'bg-indigo-500',
  },
  {
    review:
      'One of the best extensions one can ask for. Must for a linkedin user.Highly recommend this.',
    name: 'Karshit Chawla',
    designation: 'Analyst Trainee @PoleStar Solutions',
    color: 'bg-rose-500',
  },
];
